import React, { createContext, useCallback, useState } from 'react';

export const CookieContext = createContext<{
  setCookie: (key: string, value: string) => void;
  getCookie: (key: string) => string;
}>({
  getCookie: () => {
    console.error('getCookie must be used within a CookieProvider');
    return '';
  },
  setCookie: () => {
    console.error('setCookie must be used within a CookieProvider');
  },
});

export default function CookieProvider({
  children,
}: {
  children?: React.ReactNode;
}) {
  const getCookieValue = (name: string) =>
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

  const [values, setValues] = useState<ObjectMap>({});

  const setCookie = useCallback(
    (key: string, value: any) => {
      if (key in values && values[key] === value) {
        return;
      }

      const expiry = new Date();
      expiry.setDate(expiry.getDate() + 100);
      document.cookie = `${key}=${value}; expires=${expiry.toUTCString()}; path=/`;
      setValues({ ...values, [key]: value });
    },
    [values]
  );

  const getCookie = useCallback(
    (key: string) => {
      if (key in values) {
        return values[key];
      }

      const cookieValue = getCookieValue(key);
      setValues({ ...values, [key]: cookieValue });
      return cookieValue;
    },
    [values]
  );

  return (
    <CookieContext.Provider value={{ setCookie, getCookie }}>
      {children}
    </CookieContext.Provider>
  );
}
